var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useMemo, useState } from 'react';
import { useLoader } from 'ziphy-web-shared/basic/hooks';
import { getTelehealthAppointmentId } from '@core/src/nedoShared/modules/dashboard/dashboard.helper';
import $livequeueConsultation from '@core/src/store/livequeueConsultationsStore';
import clientService from '@services/client';
export const useLoadAppointment = () => {
    const consultation = $livequeueConsultation.selectedConsultation;
    const telehealthId = getTelehealthAppointmentId((consultation === null || consultation === void 0 ? void 0 : consultation.attachments) || []);
    const [apptData, setApptData] = useState(undefined);
    // fetch a single appointment for Notes section
    const fetchSingleAppointment = (id) => __awaiter(void 0, void 0, void 0, function* () {
        const idNum = Number(id);
        const resAppt = yield clientService.getOneAppointment({
            id: Number.isNaN(idNum) ? id : idNum,
            skipAlert: true,
            getEvents: false,
            checkRoles: false,
            expand: {
                encounter: ['patientId', 'patientSymptomsId'],
                appointment: [
                    'serviceId',
                    'placeId',
                    'officeId',
                    'practiceId',
                    'encounterIds',
                    'providerRoleId',
                    'status',
                ],
            },
        });
        return resAppt === null || resAppt === void 0 ? void 0 : resAppt.prepared;
    });
    useEffect(() => {
        if (!telehealthId)
            setApptData(undefined);
    }, [telehealthId]);
    const { isLoading: isApptLoading } = useLoader(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!telehealthId)
            return;
        const full = yield fetchSingleAppointment(telehealthId);
        setApptData(full);
    }), [telehealthId]);
    const { appointment: appt, encounters, patients, practice, } = useMemo(() => {
        return apptData
            ? {
                appointment: apptData.appointment,
                encounters: apptData.encounters,
                patients: apptData.patients,
                practice: apptData.practice,
            }
            : {};
    }, [apptData]);
    const activeEncounter = useMemo(() => {
        var _a;
        if (!appt || !encounters)
            return undefined;
        const firstEncounterId = (_a = appt.encounterIds) === null || _a === void 0 ? void 0 : _a[0]; // todo check encounter id first or ?
        return firstEncounterId ? encounters === null || encounters === void 0 ? void 0 : encounters[firstEncounterId] : undefined;
    }, [appt, encounters]);
    const activePatient = useMemo(() => {
        if (!activeEncounter || !patients)
            return undefined;
        return patients === null || patients === void 0 ? void 0 : patients[activeEncounter === null || activeEncounter === void 0 ? void 0 : activeEncounter.patientId];
    }, [activeEncounter, patients]);
    return {
        appt,
        apptData,
        encounters,
        patients,
        practice,
        activeEncounter,
        activePatient,
        isApptLoading,
        loadAppointmentById: fetchSingleAppointment,
    };
};
